import ImportPeopleModal from './ImportPeopleModal';
import SearchBar from './SearchBar';

const People = () => ({});
People.ImportPeopleModal = ImportPeopleModal;
People.SearchBar = SearchBar;

export default People;
